import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const FOOTER_LINKS = [
  { to: "/terms-and-conditions", label: "Terms & Conditions", testId: "footer-terms-link" },
  { to: "/privacy-policy", label: "Privacy Policy", testId: "footer-privacy-link" },
  { to: "/disclaimer", label: "Disclaimer of Use", testId: "footer-disclaimer-link" },
  { to: "/about", label: "About Us", testId: "footer-about-link" },
  { to: "/contact", label: "Contact Us", testId: "footer-contact-link" },
  { to: "/affiliate-disclosure", label: "Affiliate Disclosure", testId: "footer-affiliate-disclosure-link" },
  { to: "/editorial-policy", label: "Editorial Policy", testId: "footer-editorial-policy-link" },
  { to: "/commercial-relationships", label: "Commercial Relationships", testId: "footer-commercial-relationships-link" },
];

export const Footer = () => (
  <footer className="bg-[#0F172A] text-slate-300" data-testid="site-footer">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="max-w-4xl mx-auto text-center space-y-6">
        <p className="text-sm text-slate-400 leading-relaxed" data-testid="footer-affiliate-disclaimer">
          <span className="font-bold text-slate-300">Affiliate Disclaimer:</span> VoiceRanker.ai is reader-supported. Some links on this website are affiliate links, which means we may earn a commission if you purchase through them, at no additional cost to you. We currently have an affiliate relationship with ElevenLabs. Affiliate partnerships never influence our editorial comparisons, rankings or recommendations. For more information, please see our{" "}
          <Link to="/affiliate-disclosure" className="text-[#8B7BFF] hover:text-white transition-colors font-semibold">Affiliate Disclosure</Link> and{" "}
          <Link to="/editorial-policy" className="text-[#8B7BFF] hover:text-white transition-colors font-semibold">Editorial Standards &amp; Ranking Policy</Link>.
        </p>
        <p className="text-sm text-slate-400 leading-relaxed" data-testid="footer-trademark-disclaimer">
          <span className="font-bold text-slate-300">Trademark Disclaimer:</span> All trademarks, logos, product names and company names are the property of their respective owners. Their use on VoiceRanker.ai is solely for identification, comparison and editorial purposes and does not imply any endorsement or affiliation unless expressly stated.
        </p>
      </div>
      <nav className="flex flex-col sm:flex-row flex-wrap items-start sm:items-center justify-center gap-y-5 gap-x-8 lg:gap-x-10 mt-12" data-testid="footer-links-row">
        {FOOTER_LINKS.map(({ to, label, testId }) => (
          <Link
            key={to}
            to={to}
            data-testid={testId}
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-300 hover:text-white transition-colors duration-200"
          >
            {label}
            <ChevronRight className="w-4 h-4 text-slate-500" />
          </Link>
        ))}
      </nav>
      <div className="border-t border-white/15 mt-12 pt-8 text-center">
        <p className="text-sm text-slate-300" data-testid="footer-copyright">© Copyright 2026 — All Rights Reserved</p>
        <p className="mt-3 text-sm text-slate-400" data-testid="footer-domain">voiceranker.ai</p>
        <p className="mt-4 text-xs text-slate-500">VoiceRanker.ai is operated by Digital Media Strategies Ltd.</p>
      </div>
    </div>
  </footer>
);
